// ═══════════════════════════════════════════════
//   RESTOCK RUSH — conveyor belt minigame
// ═══════════════════════════════════════════════
//
// Objective:   Drag products from the conveyor onto the shelves that need
//              them before the timer runs out.
// Type:        sorter
// Description: Mouse drag-and-drop. The belt accelerates and spawn rate
//              ramps up over the GAME_RESTOCK.timer-second round. Reward is
//              per end-of-run score.
// Tunables:    GAME_RESTOCK in data.js.

const {canvas, ctx, claimGameReward, addCleanup, showGameOver} = window;

const RST_EMOJI = ['🥫', '🍙', '🍜', '🍵', '🍡', '🧃', '🍫', '🍬'];

// Belt layout constants (visual, not tunable as difficulty)
const RST_BELT_TOP = 142;
const RST_BELT_H   = 68;
const RST_IW       = 56;
const RST_IH       = 56;
const RST_ITEM_Y   = RST_BELT_TOP + (RST_BELT_H - RST_IH) / 2;

let rstProds = [];
window.rstShelves  = [];
window.rstBelt     = [];
window.rstDragItem = null;
let rstBeltOffset = 0;
let rstBeltSpeed  = 0;
let rstSpawnCtr   = 0;
let rstSpawnEvery = 0;
let rstItemId     = 0;
let rstMx = 0, rstMy = 0;

function startRestock() {
    const CFG = window.GAME_RESTOCK;
    window.gameRunning  = true;
    window.gameScore    = 0;
    window.gameTimer    = CFG.timer;
    rstProds            = [];
    window.rstShelves   = [];
    window.rstBelt      = [];
    window.rstDragItem  = null;
    rstBeltOffset       = 0;
    rstBeltSpeed        = CFG.beltSpeedInit;
    rstSpawnCtr         = 0;
    rstSpawnEvery       = CFG.spawnInit;
    rstItemId           = 0;
    document.getElementById('mg-timer').textContent = CFG.timer + 's';
    document.getElementById('mg-score').textContent = '0';

    let pending = 8, found = [];
    for (let i = 1; i <= 8; i++) {
        const img = new Image(), id = i;
        img.onload  = () => { found.push({id, img, emoji: null}); done(); };
        img.onerror = () => done();
        img.src = `assets/games/stock/stock_${i}.png`;
    }

    function done() {
        if (--pending > 0) return;
        rstProds = found.length >= 2
            ? found
            : RST_EMOJI.slice(0, 4).map((e, i) => ({id: i + 1, img: null, emoji: e}));
        rstInitBelt();
    }
}

function rstRandProd() {
    return rstProds[Math.floor(Math.random() * rstProds.length)];
}

function rstInitBelt() {
    const CFG = window.GAME_RESTOCK;
    const gap = 5, sw = Math.floor((canvas.width - gap * 4) / 3), sh = 104;
    window.rstShelves = [0, 1, 2].map(i => ({
        x: gap + (sw + gap) * i, y: 8, w: sw, h: sh,
        needId: rstRandProd().id, flash: 0, flashOk: false
    }));

    // Burst: first item + extra items staggered so the belt feels alive immediately
    rstSpawnOne();
    for (let i = 1; i <= CFG.spawnBurst; i++) {
        const p = rstRandProd();
        window.rstBelt.push({
            id: rstItemId++, prodId: p.id, img: p.img, emoji: p.emoji,
            x: -(RST_IW + 6) * (i + 1),
            grabbed: false, dragX: 0, dragY: 0, dox: 0, doy: 0,
            used: false, warnedSfx: false
        });
    }

    window.timerInterval = setInterval(() => {
        window.gameTimer--;
        document.getElementById('mg-timer').textContent = window.gameTimer + 's';
        const elapsed = CFG.timer - window.gameTimer;
        rstBeltSpeed  = CFG.beltSpeedInit + elapsed * CFG.beltSpeedRamp;
        rstSpawnEvery = Math.max(CFG.spawnMin, CFG.spawnInit - Math.floor(elapsed * CFG.spawnRamp));
        if (window.gameTimer <= 0) endRestock();
    }, 1000);
    addCleanup(() => clearInterval(window.timerInterval));

    window.gameInterval = setInterval(rstDraw, 16);
    addCleanup(() => clearInterval(window.gameInterval));

    canvas.addEventListener('mousedown', rstDown);
    canvas.addEventListener('mouseup',   rstUp);
    canvas.addEventListener('mousemove', rstMove);
    addCleanup(() => canvas.removeEventListener('mousedown', rstDown));
    addCleanup(() => canvas.removeEventListener('mouseup',   rstUp));
    addCleanup(() => canvas.removeEventListener('mousemove', rstMove));
    addCleanup(() => {
        window.rstShelves  = [];
        window.rstBelt     = [];
        window.rstDragItem = null;
    });
}

function rstSpawnOne() {
    const p = rstRandProd();
    window.rstBelt.push({
        id: rstItemId++, prodId: p.id, img: p.img, emoji: p.emoji,
        x: -RST_IW - 6,
        grabbed: false, dragX: 0, dragY: 0, dox: 0, doy: 0,
        used: false, warnedSfx: false
    });
}

function rstMove(e) {
    const {x, y} = canvasPos(e);
    rstMx = x;
    rstMy = y;
}

function rstDown(e) {
    if (!window.gameRunning) return;
    const {x: mx, y: my} = canvasPos(e);
    for (let i = window.rstBelt.length - 1; i >= 0; i--) {
        const item = window.rstBelt[i];
        if (item.grabbed || item.used) continue;
        if (mx >= item.x && mx <= item.x + RST_IW &&
            my >= RST_ITEM_Y && my <= RST_ITEM_Y + RST_IH) {
            item.grabbed = true;
            item.dragX   = item.x;
            item.dragY   = RST_ITEM_Y;
            item.dox     = mx - item.x;
            item.doy     = my - RST_ITEM_Y;
            window.rstDragItem = item;
            SFX.play('click');
            break;
        }
    }
}

function rstUp() {
    if (!window.rstDragItem) return;
    const item = window.rstDragItem;
    window.rstDragItem = null;
    item.grabbed = false;

    const cx = item.dragX + RST_IW / 2, cy = item.dragY + RST_IH / 2;
    let hit = false;
    for (const s of window.rstShelves) {
        if (cx >= s.x && cx <= s.x + s.w && cy >= s.y && cy <= s.y + s.h) {
            hit = true;
            if (s.needId === item.prodId) {
                window.gameScore++;
                document.getElementById('mg-score').textContent = window.gameScore;
                s.flash    = 38;
                s.flashOk  = true;
                item.used  = true;
                SFX.play('pts');
                const shelf = s;
                setTimeout(() => { shelf.needId = rstRandProd().id; shelf.flash = 0; }, 580);
            } else {
                s.flash   = 22;
                s.flashOk = false;
                item.used = true;
                SFX.play('error');
            }
            break;
        }
    }
    if (!hit) item.used = true;
}

function rstDrawImg(img, emoji, x, y, w, h, alpha) {
    ctx.globalAlpha = alpha ?? 1;
    if (img && img.complete && img.naturalWidth > 0) {
        const r = Math.min((w - 6) / img.naturalWidth, (h - 6) / img.naturalHeight);
        const iw = img.naturalWidth * r, ih = img.naturalHeight * r;
        ctx.drawImage(img, x + (w - iw) / 2, y + (h - ih) / 2, iw, ih);
    } else if (emoji) {
        ctx.font = `${Math.floor(h * 0.52)}px serif`;
        ctx.textAlign = 'center';
        ctx.fillText(emoji, x + w / 2, y + h * 0.72);
    }
    ctx.globalAlpha = 1;
}

function rstDraw() {
    if (!window.gameRunning) return;
    const W = canvas.width, H = canvas.height;

    // Advance belt
    rstBeltOffset = (rstBeltOffset + rstBeltSpeed) % 40;
    rstSpawnCtr++;
    if (rstSpawnCtr >= rstSpawnEvery) {
        rstSpawnCtr = 0;
        rstSpawnOne();
    }

    // Move non-grabbed items; remove those that scrolled off
    for (const item of window.rstBelt) {
        if (!item.grabbed && !item.used) {
            item.x += rstBeltSpeed;
            // Urgency warning — only when a shelf actually needs this product
            if (!item.warnedSfx && item.x > W * 0.72) {
                item.warnedSfx = true;
                if (window.rstShelves.some(s => s.needId === item.prodId)) SFX.play('hit');
            }
            if (item.x > W + 8) {
                if (window.rstShelves.some(s => s.needId === item.prodId)) SFX.play('damage');
                item.used = true;
            }
        }
    }

    if (window.rstDragItem) {
        window.rstDragItem.dragX = rstMx - window.rstDragItem.dox;
        window.rstDragItem.dragY = rstMy - window.rstDragItem.doy;
    }
    window.rstBelt = window.rstBelt.filter(it => !it.used || it === window.rstDragItem);

    // Background
    ctx.fillStyle = '#fdf6e3';
    ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = '#f5ebe0';
    ctx.fillRect(0, 0, W, 118);

    // Shelves
    for (const s of window.rstShelves) {
        if (s.flash > 0) s.flash--;
        const ok  = s.flash > 0 && s.flashOk;
        const bad = s.flash > 0 && !s.flashOk;
        ctx.fillStyle   = ok ? 'rgba(168,224,99,.55)' : bad ? 'rgba(247,37,133,.18)' : 'rgba(255,255,255,.8)';
        ctx.strokeStyle = ok ? '#a8e063' : bad ? '#f72585' : 'rgba(0,0,0,.2)';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.roundRect(s.x, s.y, s.w, s.h, 8);
        ctx.fill();
        ctx.stroke();
        const need = rstProds.find(p => p.id === s.needId) || rstProds[0];
        if (need) rstDrawImg(need.img, need.emoji, s.x + 4, s.y + 4, s.w - 8, s.h - 20, ok ? 1 : 0.22);
        ctx.font      = '5px "Press Start 2P",monospace';
        ctx.textAlign = 'center';
        ctx.fillStyle = ok ? '#166534' : '#f72585';
        ctx.fillText(ok ? '✓ PERFECT!' : 'PUT HERE →', s.x + s.w / 2, s.y + s.h - 5);
    }

    // Shelf plank
    ctx.fillStyle = '#c8975a';
    ctx.fillRect(0, 116, W, 10);
    ctx.fillStyle = '#9e6b35';
    ctx.fillRect(0, 126, W, 4);

    // Conveyor belt body
    ctx.fillStyle = '#6b7280';
    ctx.fillRect(0, RST_BELT_TOP, W, RST_BELT_H);
    // Animated diagonal stripes
    const sw = 36;
    for (let x = (rstBeltOffset % sw) - sw; x < W + sw; x += sw) {
        ctx.fillStyle = 'rgba(0,0,0,0.11)';
        ctx.beginPath();
        ctx.moveTo(x, RST_BELT_TOP);
        ctx.lineTo(x + sw * 0.55, RST_BELT_TOP);
        ctx.lineTo(x + sw * 0.55 - 10, RST_BELT_TOP + RST_BELT_H);
        ctx.lineTo(x - 10, RST_BELT_TOP + RST_BELT_H);
        ctx.closePath();
        ctx.fill();
    }
    ctx.fillStyle = 'rgba(255,255,255,0.07)';
    ctx.fillRect(0, RST_BELT_TOP, W, RST_BELT_H * 0.35);
    ctx.fillStyle = '#4b5563';
    ctx.fillRect(0, RST_BELT_TOP, W, 7);
    ctx.fillRect(0, RST_BELT_TOP + RST_BELT_H - 7, W, 7);
    ctx.fillStyle = '#374151';
    for (let x = 16; x < W; x += 32) {
        ctx.beginPath(); ctx.arc(x, RST_BELT_TOP + 3, 3, 0, Math.PI * 2); ctx.fill();
        ctx.beginPath(); ctx.arc(x, RST_BELT_TOP + RST_BELT_H - 4, 3, 0, Math.PI * 2); ctx.fill();
    }

    // Belt items (non-grabbed)
    for (const item of window.rstBelt) {
        if (item.grabbed || item.used) continue;
        ctx.fillStyle   = 'white';
        ctx.strokeStyle = '#1a0010';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.roundRect(item.x, RST_ITEM_Y, RST_IW, RST_IH, 8);
        ctx.fill();
        ctx.stroke();
        rstDrawImg(item.img, item.emoji, item.x + 2, RST_ITEM_Y + 2, RST_IW - 4, RST_IH - 4, 1);
        if (item.x > W * 0.72) {
            ctx.strokeStyle = '#f72585';
            ctx.lineWidth = 2.5;
            ctx.beginPath();
            ctx.roundRect(item.x, RST_ITEM_Y, RST_IW, RST_IH, 8);
            ctx.stroke();
        }
    }

    // Dragged item (always on top)
    if (window.rstDragItem && !window.rstDragItem.used) {
        const d = window.rstDragItem;
        ctx.fillStyle = 'rgba(0,0,0,0.18)';
        ctx.beginPath();
        ctx.roundRect(d.dragX + 5, d.dragY + 6, RST_IW, RST_IH, 8);
        ctx.fill();
        ctx.fillStyle   = 'white';
        ctx.strokeStyle = '#f72585';
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.roundRect(d.dragX, d.dragY, RST_IW, RST_IH, 8);
        ctx.fill();
        ctx.stroke();
        rstDrawImg(d.img, d.emoji, d.dragX + 2, d.dragY + 2, RST_IW - 4, RST_IH - 4, 1);
    }

    // Instruction text
    ctx.font      = '5px "Press Start 2P",monospace';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#9d4e6a';
    ctx.fillText('GRAB ITEMS FROM BELT  →  DROP ON MATCHING SHELF', W / 2, H - 6);
}

function endRestock() {
    window.gameRunning = false;
    const CFG = window.GAME_RESTOCK;
    if (window.gameScore >= CFG.nickThreshold) window.unlockNick('restocker');
    const p = Math.min(CFG.rewardMax, window.gameScore * CFG.rewardPerScore);
    showGameOver(claimGameReward('restock', window.gameScore, p));
}

window.startRestock = startRestock;
window.endRestock   = endRestock;
window.rstDown      = rstDown;
window.rstUp        = rstUp;
window.rstMove      = rstMove;
